// '2019-08-30 00:00:00' => Timestamp
function getTimestamp(strtime) {
  var date = new Date(strtime.replace(/-/g, '/'))
  return date.getTime()
}

export default {
  getTimestamp,
}